<template>
    <div v-if="data" class="w-full flex flex-column gap-2 xl:gap-3 lg:gap-3 md:gap-3">
        <div v-if="is_admin && isUserInGroup('admin')" class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row 
            gap-2 xl:gap-3 lg:gap-3 md:gap-3">
            <div class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                    Плат.сис. приема:
                </span>
                <div v-if="data.pays_get_codes && data.pays_get_codes.length>0" class="m-0">
                    <div v-for="code in data.pays_get_codes" class="inline-block relative p-1 border-round-md surface-0 mr-2 mb-2" style="line-height:15px">
                        <img :src="getPaySysImage(code)" class="absolute top-0 mt-1 left-0 ml-1" style="max-width: 15px;">
                        <span class="text-xs inline-block white-space-nowrap float-left m-0 pl-4" >{{ getPaySysTitle(code) }}</span>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <span class="flex text-600 mb-2 text-sm">
                    Плат.сис. отправки:
                </span>
                <div v-if="data.pays_send_codes && data.pays_send_codes.length>0" class="m-0">
                    <div v-for="code in data.pays_send_codes" class="inline-block relative p-1 border-round-md surface-0 mr-2 mb-2" style="line-height:15px">
                        <img :src="getPaySysImage(code)" class="absolute top-0 mt-1 left-0 ml-1" style="max-width: 15px;">
                        <span class="text-xs inline-block white-space-nowrap float-left m-0 pl-4" >{{ getPaySysTitle(code) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row pr-0">
            <div v-if="data" class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <span class="flex text-600 mb-2 text-sm">
                    Банки приема:
                </span>
                <div v-if="data.get_bank_codes && data.get_bank_codes.length>0" class="m-0">
                    <div v-for="code in data.get_bank_codes" class="inline-block relative mb-0 p-1 border-round-md surface-0 mr-2 mb-2" style="line-height:15px">
                        <img :src="getBankImage(code)" class="absolute top-0 mt-1 left-0 ml-1" style="max-width: 15px;">
                        <span class="text-xs inline-block white-space-nowrap float-left m-0 pl-4" >{{ getBankTitle(code) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row pr-0">
            <div v-if="data" class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <span class="flex text-600 mb-2 text-sm">
                    Банки отправки:
                </span>

                <div v-if="merchant_id && sendBanks && sendBanks.length>=0" class="m-0">
                    <BanksEditor :bank_codes="sendBanks" :show_list="true" type="send"
                        @update="updateBanks" :close="closeBanks" :loading="loading"/> 
                </div>
                <Skeleton v-else height="2rem" class="border-round-lg"/>
            </div>
        </div>

        <div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row pr-0">
            <div v-if="data" class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <span class="flex text-600 mb-2 text-sm">
                    Резервы на отправку:
                </span>

                <div v-if="merchant_id && reserves && reserves.length>=0" class="w-full">
                    <Reserves :merchant_id="merchant_id" :reserves="reserves"
                        @update="updateReserves" :close="closeReserves" :loading="loading"/>
                </div>
                <Skeleton v-else height="2rem" class="border-round-lg"/>
            </div>
        </div>
        <div v-if="!data" class="px-0 xl:px-3 lg:px-3 md:px-3">
            <Skeleton  height="3rem" class="border-round-lg"/> 
        </div>
    </div>
    <Skeleton v-else height="3rem" class="border-round-lg"/>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import BanksEditor from '@/components/merchant/BanksEditor.vue'
import Reserves from '@/components/merchant/Reserves.vue'
import { PaymentSystemList, BankList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    props: ['data', 'merchant_id', 'is_admin'],
    data() {
        return {
            sendBanks: [],
            reserves: [],
            closeBanks: false,
            closeReserves: false,
            pays: [],
            banks: [],
        }
    },
    components: {
        BanksEditor,
        Reserves
    },
    watch: {
        data(){
            if(this.data && this.data.send_bank_codes){
                this.sendBanks = this.data.send_bank_codes
            }
            if(this.data && this.data.reserves){
                this.reserves = this.data.reserves
            }
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.banks
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.banks
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : code
        },
        getPaySysTitle(code){
            let paySysObj = new PaymentSystemList()
            paySysObj.items = this.pays
            const paySysCode = paySysObj.GetTitle(code, this.lang_)
            return (paySysCode) ? paySysCode : code
        },
        getPaySysImage(code){
            let paySysObj = new PaymentSystemList()
            paySysObj.items = this.pays
            const paySysCode = paySysObj.GetImage(code)
            return (paySysCode) ? paySysCode : null
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        async updateBanks(val){
            if(!val) return false
            if(!val.bank_codes) return false
            this.closeBanks = false
           
            this.sendBanks = val.bank_codes
            const data = {
                id: this.merchant_id,
                send_bank_codes: this.sendBanks,
            }
            if(this.is_admin && (this.isUserInGroup('admin') || this.isUserInGroup('manager'))) await this.updateByAdmin(data).then(res=>res)
            else await this.updateByMerchant(data).then(res=>res)
            this.closeBanks = true
            
        },
        async updateReserves(val){
            this.closeReserves = false
            const data = {
                id: this.merchant_id,
                reserves: (val && val.length>0) ? val : [],
            }
            if(this.is_admin && (this.isUserInGroup('admin') || this.isUserInGroup('manager'))) await this.updateByAdmin(data).then(res=>res)
            else await this.updateByMerchant(data).then(res=>res)
            this.closeReserves = true
        },
        async updateByMerchant(data){
            if(!data) return false
            this.loading = true
            const upd = await this.connect.UpdateByMerhcant(data).then(res=>res)
            if(upd.result){
                this.showMess('success', 'Успех', 'Мерчант изменен')
            }else{
                try{
                    for (let i = 0; i < upd.errors.length; i++) {
                        this.showMess('error', 'Ошибка', upd.errors[i])
                    }
                }catch(e){
                    this.showMess('error', 'Ошибка', 'Ошибка при изменении мерчанта')
                    console.log('error', e)
                }
            }
            this.loading = false
        },
        async updateByAdmin(data){
            if(!data) return false
            this.loading = true
            const upd = await this.connect.UpdateMerchantByAdmin(data).then(res=>res)
            if(upd.result){
                this.showMess('success', 'Успех', 'Мерчант изменен администратором')
            }else{
                try{
                    for (let i = 0; i < upd.errors.length; i++) {
                        this.showMess('error', 'Ошибка', upd.errors[i])
                    }
                }catch(e){
                    this.showMess('error', 'Ошибка', 'Ошибка при изменении мерчанта администратором')
                    console.log('error', e)
                }
            }
            this.loading = false
        },
        async LoadPays(){
            try { 
                this.pays = await PaymentSystemList.GetList(this.$store).then(r=>r)
                if(!this.pays || !this.pays.length) this.pays = []
            } catch { console.log('error store get pays')}
        },
        async LoadBanks(){
            try { 
                this.banks = await BankList.GetList(this.$store).then(r=>r)
                if(!this.banks || !this.banks.length) this.banks = []
                else this.totalRecords = this.banks.length
            } catch { console.log('error store get banks')}
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted(){
        this.LoadPays()
        this.LoadBanks()
    }
}
</script>